/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const IconGridView = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconGridView"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 13v7H4v-7zm9 0v7h-7v-7zM9 15H6v3h3zm9 0h-3v3h3zM11 4v7H4V4zm9 0v7h-7V4zM9 6H6v3h3zm9 0h-3v3h3z"
    />
  </svg>
);
export default IconGridView;
